import { useState, useEffect, useRef } from "react";
import { DatePicker, Spin, TimePicker } from "antd";
import Select from "react-select";
import { parsePhoneNumber } from "libphonenumber-js";
import dayjs from "dayjs";
import api from "../../../axios/axiosInstance";
import {
  clearContactsCache,
  clearContactDetailsCache,
  fetchContactsWithCache,
} from "../../../data/redux/slices/ContactSlice";
import {
  clearContactsCache as clearLeadsCache,
  clearContactDetailsCache as clearLeadDetailsCache,
  fetchContactsWithCache as fetchLeadsWithCache,
} from "../../../data/redux/slices/LeadSlice";
import {
  fetchCallHistory,
  setFetchAndStoreLoading,
} from "../../../data/redux/slices/CallHistorySlice";
import { fetchCallHistoryAgent } from "../../../data/redux/slices/CallHistoryAgentSlice";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../data/redux/slices/ToastSlice";
import { meetingType } from "../../selectoption/selectoption";
import { LoadingOutlined } from "@ant-design/icons";

const AfterCallOffcanvas = ({ selectedLead, phoneNumber, firstName, lastName, callStartedAt, onAfterSave }) => {

  const [openModal2, setOpenModal2] = useState(false);
  const [selectedMeetingType, setSelectedMeetingType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const closeBtnRef = useRef(null);

  const [formData, setFormData] = useState({
    phoneNumbers: {
      countryCode: "",
      number: "",
    },
    status: "",
    note: "",
    firstname: firstName || "",
    lastname: lastName || "",
    meeting: {
      meetingTitle: "",
      meetingDescription: "",
      meetingStartDate: "",
      meetingStartTime: "",
      meetingType: "offline",
      meetingLocation: "",
    },
  });





  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      firstname: firstName || "",
      lastname: lastName || "",
      phoneNumbers: phoneNumber
        ? (() => {
          try {
            const parsed = parsePhoneNumber(
              phoneNumber.startsWith("+") ? phoneNumber : "+" + phoneNumber
            );
            return parsed ? { countryCode: parsed.countryCallingCode, number: parsed.nationalNumber } : { countryCode: "", number: "" };
          } catch {
            const match = phoneNumber.match(/^\+?(\d{1,4})(\d+)$/);
            return match ? { countryCode: match[1], number: match[2] } : { countryCode: "", number: "" };
          }
        })()
        : { countryCode: "", number: "" },
    }));
  }, [firstName, lastName, phoneNumber, callStartedAt]);




  function splitName(fullName = "") {
    const parts = fullName.trim().split(/\s+/);
    return {
      firstname: parts[0] || "",
      lastname: parts.slice(1).join(" ") || "",
    };
  }

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };


  const handleMeetingChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      meeting: {
        ...prev.meeting,
        [field]: value,
      },
    }));
  };


  const handleStatusChange = (status) => {
    setFormData((prev) => ({
      ...prev,
      status: status,
    }));
  };



  const handleSave = async () => {
    try {
      setIsLoading(true)
      const payload = {
        phoneNumbers: {
          countryCode: String(formData.phoneNumbers.countryCode || ""),
          number: String(formData.phoneNumbers.number || ""),
        },
        firstname: formData.firstname,
        lastname: formData.lastname,
        status: formData.status || undefined,
        note: formData.note || undefined,
        meetingProvider: "google",

        meeting:
          formData.status === "interested" ? formData.meeting : undefined,
      };
      for (const key in payload) {
        console.log(key, ":", payload[key], "payloadd");
      }


      const response = await api.post("/call/addFormDataAfterCallEnd", payload);
      closeBtnRef.current?.click();
      if (typeof onAfterSave === "function") {
        onAfterSave(formData.status);
      }
      dispatch(clearContactsCache());
      dispatch(clearContactDetailsCache());
      dispatch(clearLeadsCache());
      dispatch(clearLeadDetailsCache());


      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const last7Start = new Date(today);
      last7Start.setDate(today.getDate() - 7);


      setFormData({
        phoneNumbers: {
          countryCode: "",
          number: "",
        },
        status: "",
        note: "",
        firstname: "",
        lastname: "",
        meeting: {
          meetingTitle: "",
          meetingDescription: "",
          meetingStartDate: "",
          meetingStartTime: "",
          meetingType: "offline",
          meetingLocation: "",
          meetingProvider: "",
        },
      });


      dispatch(
        showToast({
          message:
            response.data.type == "convertedLead"
              ? response.data.message + ", contact converted to lead"
              : response.data.message,
          variant: "success",
        })
      );
      setOpenModal2(true);
    } catch (err) {
      console.error("Failed to save after-call form:", err);
      setIsLoading(false)
      dispatch(
        showToast({
          message: "After call form failed to submit",
          variant: "danger",
        })
      );

    } finally {
      setIsLoading(false)
      dispatch(setFetchAndStoreLoading(false));
    }
  };

  return (
    <div
      className="offcanvas offcanvas-end offcanvas-large"
      tabIndex={-1}
      style={{ zIndex: 2000 }}
      id="afterCall_offcanvas"
      aria-modal="true"
      role="dialog"
    >

      <button
        ref={closeBtnRef}
        type="button"
        data-bs-dismiss="offcanvas"
        style={{ display: "none" }}
      >
      </button>
      <div className="offcanvas-header border-bottom">
        <h5 className="fw-semibold">
          {selectedLead ? "Call Summary" : "Call Summary"}
        </h5>
        <button
          type="button"
          className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        >
          <i className="ti ti-x" />
        </button>
      </div>
      <div className="offcanvas-body">
        <div className="row">
          <div className="d-flex gap-3">
            <div className="mb-3 w-50">
              <label className="col-form-label">First name</label>
              <input
                className="form-control"
                type="text"
                value={formData.firstname}
                onChange={(e) => handleChange("firstname", e.target.value)}
                required
              />
            </div>

            <div className="mb-3 w-50">
              <label className="col-form-label">Last name</label>
              <input
                className="form-control"
                type="text"
                value={formData.lastname}
                onChange={(e) => handleChange("lastname", e.target.value)}
                required
              />
            </div>
          </div>
          <div className="mb-4 flex-1">
            <h6 className="fw-semibold mb-3">Notes</h6>
            <div className="card bg-light">
              <textarea
                className="form-control"
                rows={3}
                value={formData.note}
                onChange={(e) => handleChange("note", e.target.value)}
                placeholder="Add notes about this contact..."
              />
            </div>
          </div>

          <div className="mb-4">
            <h6 className="fw-semibold mb-2">Select Status</h6>
            <div className="d-flex gap-2 flex-wrap">
              {[
                { value: "callBack", label: "Call Back" },
                { label: "No Answer", value: "noAnswer" },
                { label: "Meeting", value: "interested" },
                { label: "Call Success", value: "callSuccess" },
              ].map((item) => (
                <div
                  key={item.value}
                  onClick={() => handleStatusChange(item.value)}
                  style={{ cursor: "pointer", flex: "1 1 auto", minWidth: "100px" }}
                  className={
                    "px-3 py-2 rounded text-center" +
                    (formData.status === item.value
                      ? " bg-primary text-white border border-primary"
                      : " bg-white text-dark border border-secondary-subtle")
                  }
                  onMouseEnter={(e) => {
                    if (formData.status !== item.value) {
                      e.currentTarget.style.backgroundColor = "#f1f1f1";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (formData.status !== item.value) {
                      e.currentTarget.style.backgroundColor = "white";
                    }
                  }}
                >
                  {item.label}
                </div>
              ))}
            </div>
          </div>

          {formData.status === "interested" && (
            <>
              <div className="mb-3">
                <label className="col-form-label">
                  Title <span className="text-danger"> *</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  value={formData?.meeting?.meetingTitle}
                  onChange={(e) =>
                    handleMeetingChange("meetingTitle", e.target.value)
                  }
                  required
                />
              </div>

              <div className="mb-3">
                <label className="col-form-label">Description</label>
                <textarea
                  className="form-control"
                  rows={2}
                  value={formData?.meeting?.meetingDescription}
                  onChange={(e) =>
                    handleMeetingChange("meetingDescription", e.target.value)
                  }
                  placeholder="Add meeting description..."
                />
              </div>




              <div className="col-md-12 mb-3">
                <label className="col-form-label">
                  Start Date & Time <span className="text-danger"> *</span>
                </label>

                <div className="icon-form-end">
                  <span className="form-icon">
                    <i className="ti ti-calendar-event" />
                  </span>




                  {/* <DatePicker
                    className="form-control datetimepicker deals-details"
                    format="DD-MM-YYYY hh:mm A"
                    showTime={{
                      use12Hours: true,
                      format: "hh:mm A",
                    }}
                    value={
                      formData?.meeting?.meetingStartDate
                        ? formData?.meeting?.meetingStartTime
                          ? dayjs(
                            `${formData?.meeting?.meetingStartDate} ${formData?.meeting?.meetingStartTime}`,
                            "YYYY-MM-DD hh:mm A"  // ✅ Changed from HH:mm to hh:mm A
                          )
                          : dayjs(formData?.meeting?.meetingStartDate, "YYYY-MM-DD")
                        : null
                    }
                    onChange={(date) => {
                      if (!date) {
                        setFormData({
                          ...formData,
                          meeting: {
                            ...formData.meeting,
                            meetingStartDate: null,
                            meetingStartTime: null,
                          },
                        });
                        return;
                      }

                      setFormData({
                        ...formData,
                        meeting: {
                          ...formData.meeting,
                          // ✅ Store date in YYYY-MM-DD
                          meetingStartDate: date.format("YYYY-MM-DD"),
                          // ✅ Store time in hh:mm A (12-hour format) - changed from HH:mm A
                          meetingStartTime: date.format("hh:mm A"),
                        },
                      });
                    }}
                  /> */}


                  <DatePicker
                    className="form-control datetimepicker deals-details"
                    format="DD-MM-YYYY hh:mm A"
                    showTime={{
                      use12Hours: true,
                      format: "hh:mm A",
                    }}
                    value={
                      formData?.meeting?.meetingStartDate
                        ? formData?.meeting?.meetingStartTime
                          ? dayjs(
                            `${formData?.meeting?.meetingStartDate} ${formData?.meeting?.meetingStartTime}`,
                            "YYYY-MM-DD HH:mm"
                          )
                          : dayjs(formData?.meeting?.meetingStartDate, "YYYY-MM-DD")
                        : null
                    }
                    disabledDate={(current) => {
                      // Disable all dates before today
                      return current && current < dayjs().startOf("day");
                    }}
                    disabledTime={(current) => {
                      if (!current) return {};

                      const now = dayjs();

                      // Only restrict time if the selected date is today
                      if (current.isSame(now, "day")) {
                        const currentHour = now.hour();
                        const currentMinute = now.minute();

                        return {
                          // Disable all past hours
                          disabledHours: () => Array.from({ length: currentHour }, (_, i) => i),
                          // Disable past minutes only in the current hour
                          disabledMinutes: (selectedHour) =>
                            selectedHour === currentHour
                              ? Array.from({ length: currentMinute }, (_, i) => i)
                              : [],
                          disabledSeconds: () => [], // allow any seconds
                        };
                      }

                      // No restrictions for future dates
                      return {
                        disabledHours: () => [],
                        disabledMinutes: () => [],
                        disabledSeconds: () => [],
                      };
                    }}
                    onChange={(date) => {
                      if (!date) {
                        setFormData({
                          ...formData,
                          meeting: {
                            ...formData.meeting,
                            meetingStartDate: null,
                            meetingStartTime: null,
                          },
                        });
                        return;
                      }

                      setFormData({
                        ...formData,
                        meeting: {
                          ...formData.meeting,
                          meetingStartDate: date.format("YYYY-MM-DD"),   // store date
                          meetingStartTime: date.format("HH:mm"),        // store time in 24-hour format
                        },
                      });
                    }}
                  />

                </div>
              </div>








              <div className="row">
                <div className="col-md-6 mb-3">

                  <label className="col-form-label">Meeting Type</label>
                  <Select
                    className="select2"
                    options={meetingType}
                    value={
                      formData.meeting.meetingType
                        ? meetingType.find(
                          (option) =>
                            option?.value?.toLowerCase() ===
                            formData?.meeting?.meetingType
                        )
                        : null
                    }
 
                    onChange={(option) => {
                      const type = option?.value?.toLowerCase();

                      setFormData((prev) => ({
                        ...prev,
                        meeting: {
                          ...prev.meeting,
                          meetingType: type,
                          meetingProvider: type === "online" ? "google" : undefined,
                          meetingLocation: type === "online" ? "" : prev.meeting.meetingLocation,
                        },
                      }));

                      setSelectedMeetingType(option?.value);
                    }}

                    placeholder="Choose"
                    classNamePrefix="react-select"
                  />

                </div>
                {formData.meeting.meetingType === "offline" && (
                  <div className="col-md-6 mb-3">
                    <div className="mb-3">
                      <label className="col-form-label">Location</label>

                      <input
                        className="form-control"
                        type="text"
                        value={formData.meeting.meetingLocation || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            meeting: {
                              ...prev.meeting,
                              meetingLocation: e.target.value,
                            },
                          }))
                        }
                      />

                    </div>
                  </div>
                )}


                {formData.meeting.meetingType === "online" && (
                  <div className="col-md-6 mb-3">
                    <div className="mb-3">
                      <label className="col-form-label">
                        Meeting Provider <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="select2"
                        options={[
                          { value: "google", label: "Google Meet" },
                          { value: "zoom", label: "Zoom" },
                        ]}
                        value={
                          formData.meeting.meetingProvider
                            ? [
                              { value: "google", label: "Google Meet" },
                              { value: "zoom", label: "Zoom" },
                            ].find(
                              (option) =>
                                option.value === formData.meeting.meetingProvider
                            )
                            : null
                        }

                        onChange={(option) => {
                          setFormData((prev) => ({
                            ...prev,
                            meeting: {
                              ...prev.meeting,
                              meetingProvider: option.value,
                            },
                          }));
                        }}

                        placeholder="Select Provider"
                        classNamePrefix="react-select"
                      />
                      <div className="alert alert-info d-flex align-items-center mt-2">
                        <i className="ti ti-info-circle me-2"></i>
                        <span>
                          {formData.meeting.meetingProvider === "zoom"
                            ? "A Zoom meeting link will be automatically generated when you save this meeting."
                            : formData.meeting.meetingProvider === "google"
                              ? "A Google Meet link will be automatically generated when you save this meeting."
                              : "Select a provider to create an online meeting link automatically."}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>

            </>
          )}
        </div>

        <div className="d-flex align-items-center justify-content-end">
          <button
            type="button"
            className="btn btn-primary"
            // data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading && <Spin indicator={<LoadingOutlined spin style={{ color: "white", marginRight: 5 }} />} size="small" />}Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AfterCallOffcanvas;
